import { schema, types } from 'papr'

export const cronjobSchema = schema({
	type: types.string({ required: true }),
	lastExecuted: types.date({ required: true }),
})

export type CronjobDocument = (typeof cronjobSchema)[0]
export type CronjobSchemaOptions = (typeof cronjobSchema)[1]
